"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthProvider = exports.AuthContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * CPM Auth NPM Package
 * Copyright (C) 2023 CPM
 *
 * All rights reserved.
 *
 * This software and its documentation are considered to be the Confidential and Proprietary Information of
 * CPM. Any use, copying, reproduction, modification, distribution, or disclosure directly
 * or indirectly, in whole or in part, including in derivative works, is prohibited without the express written
 * consent of CPM.
 */
//  TODO-WILL:  Consider a Redux integration for apps that support Redux
const React = __importStar(require("react"));
const utils_1 = require("./utils");
const interceptor_1 = require("./interceptor");
exports.AuthContext = React.createContext({ accessToken: (0, utils_1.getCurrentAccessToken)() });
/**
 * A utility HOC for registering the refresh heartbeat and / or the refresh interceptor.  Also provides the access token via React Context.
 * @returns
 */
const AuthProvider = ({ ssoUrl, redirect, axiosInst, interceptorCallback, heartbeatCallback, children }) => {
    if (!ssoUrl) {
        console.warn("Failed to register refresh logic no SSO URL was specified in the configuration.");
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }));
    }
    //  Access Token State
    const [accessToken, setAccessToken] = React.useState((0, utils_1.getCurrentAccessToken)());
    const syncAccessToken = () => {
        const newAccessToken = (0, utils_1.getCurrentAccessToken)();
        console.log("[Auth Provider]:  Refresh Successful:  " + newAccessToken);
        setAccessToken(newAccessToken);
    };
    //  Register Handlers on Mount
    React.useEffect(() => {
        //  Register Axios Interceptor (if needed)
        if (axiosInst) {
            (0, interceptor_1.registerRefreshInterceptor)({
                axiosInst, ssoUrl, redirect: !!redirect, callback: (accessToken, request) => {
                    syncAccessToken();
                    if (interceptorCallback) {
                        interceptorCallback(accessToken, request);
                    }
                }
            });
        }
        //  Register Refresh Heartbeat
        (0, utils_1.registerRefreshTimeout)({
            ssoUrl,
            redirect: !!redirect,
            skipInitial: true,
            callback: () => {
                syncAccessToken();
                if (heartbeatCallback) {
                    heartbeatCallback();
                }
            }
        });
    }, []);
    return ((0, jsx_runtime_1.jsx)(exports.AuthContext.Provider, { value: { accessToken }, children: children }));
};
exports.AuthProvider = AuthProvider;
